import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Main = styled.section`
  padding: 110px 0;
  position: relative;
  z-index: 10;
  background:
    radial-gradient(circle at 15% 10%, ${(props) => props.theme.text}0f 0%, transparent 42%),
    #f6f7f9;

  @media screen and (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const MaxWidth = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 22px;
  }
`;

export const Title = styled(motion.h2)`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 10px;
`;

export const Heading = styled(motion.h1)`
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  color: #0f1115;
  margin-bottom: 56px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 30px;
    margin-bottom: 40px;
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 22px;
`;

export const Card = styled(motion.div)`
  padding: 32px 28px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  box-shadow: 0 14px 34px -26px rgba(15, 17, 21, 0.5);
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: ${(props) => props.theme.text};
    box-shadow: 0 22px 50px -24px ${(props) => props.theme.text};
  }
`;

export const IconWrap = styled.div`
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  margin-bottom: 20px;
  color: ${(props) => props.theme.text};
  background: ${(props) => props.theme.text}1c;
  border: 1px solid ${(props) => props.theme.text}3a;

  svg {
    font-size: 24px;
  }
`;

export const Text = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #0f1115;
  margin-bottom: 10px;
`;

export const Parag = styled.p`
  font-size: 15px;
  line-height: 1.65;
  color: #6b7280;
`;
